import ShiftsEditComponent from "../components/ShiftsEdit";
import useShiftsEdit from "../hooks/useShiftsEdit";

const ShiftsEdit = () => {
  const useShiftsEditProps = useShiftsEdit();
  return <ShiftsEditComponent {...useShiftsEditProps} />;
};

export default ShiftsEdit;
